import { mapGetters, mapState } from 'vuex'
import { HeadingLoading } from 'components/misc'

export default {
  components: {
    HeadingLoading
  },
  computed: {
    ...mapState('app', ['loading']),
    ...mapGetters('app', ['notLoading'])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/heading-loading.js